package com.vamvisions.main.core.presentation.appshell

import com.vamvisions.main.core.domain.preferences.ColorScheme
import com.vamvisions.main.core.domain.preferences.Language

data class AppShellState(
    val colorScheme: ColorScheme,
    val language: Language,
)
